import React from "react";
import styled from "styled-components";

type SvgProps = {
  contents: any;
  width?: number;
  height?: string | number;
  color?: string;
  style?: any;
};

const SvgIcon = styled.span<{
  width?: string | number;
  height?: string | number;
  color?: string;
}>`
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  width: ${(props: any) => (props.width ? props.width + "px" : "auto")};
  height: ${(props: any) => (props.height ? props.height + "px" : "auto")};
  line-height: ${(props: any) =>
    props.height ? props.height + "px" : "inherit"};

  svg {
    display: inline-block;
    width: ${(props: any) => (props.width ? props.width + "px" : "auto")};
    height: ${(props: any) => (props.height ? props.height + "px" : "auto")};
    ${(props: any) => (props.color ? "fill:" + props.color + ";" : "")}
  }
`;

export default class Svg extends React.PureComponent<SvgProps, {}> {
  public render(): JSX.Element {
    const { contents, width, height, color } = this.props;

    return (
      <SvgIcon
        width={width}
        height={height}
        color={color}
        dangerouslySetInnerHTML={{ __html: contents }}
      />
    );
  }
}
